<form #form="ngForm" (ngSubmit)="addToShoppingList()">
  @if (isDialogView()) {
    <h3>Schnell zur Einkaufsliste</h3>
  } @else {
    <strong>Schnell zur Einkaufsliste hinzufügen</strong>
  }

  <div class="controls">
    <ui-search-suggestion-autocomplete [data]="searchInputConfig()" [formControl]="searchControl"></ui-search-suggestion-autocomplete>
    <ui-form-number [data]="productQuantityInputConfig()" [formControl]="quantityControl"></ui-form-number>
  </div>
  <div class="buttons">
    @if (isDialogView()) {
      <ui-button
        buttonStyle="text"
        type="button"
        mat-dialog-close
      >
        Schließen
      </ui-button>
    }

    <ui-button
      [buttonStyle]="isDialogView() ? 'filled' : 'outlined'"
      [disabled]="quantityControl.invalid || searchControl.invalid"
      type="submit"
    >
      zur Einkaufsliste
      @if (!isDialogView()) {
        hinzufügen
      }
    </ui-button>
  </div>
</form>
